import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderSlot as _renderSlot, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "product-card-header" }
const _hoisted_2 = { class: "product-number-row row align-center" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "title-row column q-my-sm justify-between" }
const _hoisted_5 = {
  key: 0,
  class: "product-card-notice notice inline dense warn fullwidth text-center"
}
const _hoisted_6 = { class: "product-card-contents q-my-md" }
const _hoisted_7 = { class: "sku title-row q-mb-xs" }
const _hoisted_8 = { class: "ean title-row q-mb-xs" }
const _hoisted_9 = { class: "stock-item-link q-mb-md" }
const _hoisted_10 = {
  class: "delete flex justify-center",
  style: {"margin-top":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_status_icon = _resolveComponent("status-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_form_input = _resolveComponent("form-input")!
  const _component_toggle_new = _resolveComponent("toggle-new")!
  const _component_clipable = _resolveComponent("clipable")!
  const _component_barcode_icon = _resolveComponent("barcode-icon")!
  const _component_barcode = _resolveComponent("barcode")!
  const _component_simple_link = _resolveComponent("simple-link")!
  const _component_ozn_button = _resolveComponent("ozn-button")!
  const _component_trash_icon = _resolveComponent("trash-icon")!
  const _component_chevron_left_icon = _resolveComponent("chevron-left-icon")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_entry_search = _resolveComponent("entry-search")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_expansion_item, {
      class: _normalizeClass(["cat-stock-item-card-container", { removing: _ctx.removing, highlight: _ctx.highlight, warn: !Object.keys(_ctx.catStockItem.price_list || {})?.length }]),
      ref: "expansionItem",
      "expand-icon-toggle": "",
      modelValue: _ctx.expanded,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.expanded) = $event))
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_status_icon, {
              class: "product-status",
              type: _ctx.synced,
              display: "inline",
              tooltip: _ctx.statusTooltip
            }, null, 8, ["type", "tooltip"]),
            (!_ctx.expanded)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.currentStockItem?.sku || '-'), 1))
              : (_openBlock(), _createElementBlock("p", { key: _ctx.syncedAt }, _toDisplayString(_ctx.syncedAt), 1)),
            (_ctx.editing)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 2,
                  class: "icon-undo-button",
                  flat: "",
                  rounded: "",
                  color: "primary",
                  label: "Undo changes",
                  padding: "2px 6px",
                  icon: "undo",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            (!_ctx.editing)
              ? (_openBlock(), _createElementBlock("h5", {
                  key: 0,
                  class: "card-title ellipsis",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.startEditing({ expand: true })))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.catStockItem.title || _ctx.currentStockItem?.title || '...'), 1),
                  _createVNode(_component_q_tooltip, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.catStockItem.title || _ctx.currentStockItem?.title || '...'), 1)
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createBlock(_component_form_input, {
                  key: 1,
                  "model-value": _ctx.catStockItem.title ?? _ctx.currentStockItem?.title,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateCatalogueStockItemField('title', $event))),
                  placeholder: "Title"
                }, null, 8, ["model-value"])),
            _createVNode(_component_toggle_new, {
              "model-value": _ctx.catStockItem.active ?? false,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateCatalogueStockItemField('active', $event))),
              label: _ctx.catStockItem.active ? 'Active' : 'Inactive',
              onToggle: _cache[4] || (_cache[4] = ($event: any) => (_ctx.startEditing({ expand: true})))
            }, null, 8, ["model-value", "label"])
          ]),
          (!Object.keys(_ctx.catStockItem.price_list || {})?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Item has no prices set, and cannot be ordered"))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[12] || (_cache[12] = _createElementVNode("h6", { class: "subtitle ean q-mr-md" }, "SKU", -1)),
            _createVNode(_component_clipable, {
              payload: (_ctx.currentStockItem?.sku || '') || '...',
              message: "SKU copied to clipboard"
            }, null, 8, ["payload"]),
            (!_ctx.showBarcode.sku)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  class: "barcode-icon",
                  flat: "",
                  round: "",
                  color: "primary",
                  padding: "1px",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showBarcode.sku = true))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_barcode_icon)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.currentStockItem?.sku && _ctx.showBarcode.sku)
              ? (_openBlock(), _createBlock(_component_barcode, {
                  key: 1,
                  class: "sku-datamatrix",
                  "model-value": _ctx.currentStockItem.sku,
                  format: _ctx.BarcodeTypeId.datamatrixrectangular,
                  "bar-width": 15,
                  "bar-height": 3,
                  style: {"margin-top":"-23px"}
                }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createElementVNode("div", { class: "placeholder" }, "...", -1)
                  ])),
                  _: 1
                }, 8, ["model-value", "format"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[14] || (_cache[14] = _createElementVNode("h6", { class: "subtitle ean q-mr-md" }, "EAN", -1)),
            _createVNode(_component_clipable, {
              payload: (_ctx.currentStockItem?.ean?.[0] || '') || '...',
              message: "EAN copied to clipboard"
            }, null, 8, ["payload"]),
            (!_ctx.showBarcode.ean)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  class: "barcode-icon",
                  flat: "",
                  round: "",
                  color: "primary",
                  padding: "1px",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showBarcode.ean = true))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_barcode_icon)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.currentStockItem?.ean?.length && _ctx.showBarcode.ean)
              ? (_openBlock(), _createBlock(_component_barcode, {
                  key: 1,
                  class: "sku-datamatrix",
                  "model-value": _ctx.currentStockItem.ean?.[0],
                  format: _ctx.BarcodeTypeId.datamatrixrectangular,
                  "bar-width": 15,
                  "bar-height": 3,
                  style: {"margin-top":"-23px"}
                }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createElementVNode("div", { class: "placeholder" }, "...", -1)
                  ])),
                  _: 1
                }, 8, ["model-value", "format"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("h6", {
              class: _normalizeClass(["subtitle", _ctx.currentStockItem ? '' : 'error'])
            }, _toDisplayString(_ctx.currentStockItem ? 'Product Linked' : 'Product not linked'), 3),
            (_ctx.currentStockItem)
              ? (_openBlock(), _createBlock(_component_simple_link, {
                  key: 0,
                  id: _ctx.currentStockItem.sys.id,
                  "display-field": "title",
                  medium: ""
                }, null, 8, ["id"]))
              : (_openBlock(), _createBlock(_component_ozn_button, {
                  key: 1,
                  class: "minimal",
                  flat: "",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.searchStockItems())),
                  style: {"padding-left":"0"}
                }, {
                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                    _createTextVNode("Search for stock item to link →")
                  ])),
                  _: 1
                }))
          ]),
          _renderSlot(_ctx.$slots, "product-information", { catStockItem: _ctx.catStockItem }, undefined, true),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_q_btn, {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('remove', !_ctx.removing))),
              unelevated: "",
              rounded: "",
              outline: "",
              color: _ctx.removing ? 'primary' : 'error'
            }, {
              default: _withCtx(() => [
                (!_ctx.removing)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_trash_icon, { left: "" }),
                      _cache[16] || (_cache[16] = _createElementVNode("span", null, "Delete stock item", -1))
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_chevron_left_icon),
                      _cache[17] || (_cache[17] = _createElementVNode("span", null, "Undo Removal", -1))
                    ], 64))
              ]),
              _: 1
            }, 8, ["color"])
          ])
        ])
      ]),
      _: 3
    }, 8, ["modelValue", "class"]),
    _createVNode(_component_entry_search, {
      "content-type": "stock",
      request: _ctx.request,
      show: _ctx.linkingStockItem,
      model: _ctx.stockItemModel,
      config: {..._ctx.parsedSearchConfig, requests: { ...(_ctx.parsedSearchConfig.requests || {}), limit: 250 }},
      size: "medium",
      onSelection: _ctx.linkStockItem,
      onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.linkingStockItem = false))
    }, null, 8, ["request", "show", "model", "config", "onSelection"])
  ], 64))
}